import React from 'react';

import _ from 'lodash';

import ParkerVehicle from '../../Entities/ParkerVehicle';

import ParkerVehicleTableRow from './ParkerVehicleTableRow';


class ParkerVehicleTable extends React.Component {
  _onVehicleChange(ident) {
    return vehicle => {
      const vehicles = _.cloneDeep(this.props.vehicles);

      if (ident === null) {
        vehicles.push(vehicle);
      }
      else if (vehicle === null) {
        vehicles.splice(ident, 1);
      }
      else {
        vehicles[ident] = vehicle;
      }

      this.props.onChange(vehicles);
    };
  }


  onAddVehicleClick = () => {
    this._onVehicleChange(null)(new ParkerVehicle());
  }


  render() {
    const {
      vehicles,
      fieldConfiguration,
      editMode,
      allowAdd,
      allowRemove
    } = this.props;

    return (
      <table>
        <thead>
          <tr>
            <th>Make</th>
            <th>Model</th>
            <th>License</th>
            <th>State</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        {vehicles.map((vehicle, index) => {
          return (
            <ParkerVehicleTableRow vehicle={vehicle}
              ident={index}
              fieldConfiguration={fieldConfiguration}
              editMode={editMode}
              allowRemove={allowRemove}
              onVehicleChange={this._onVehicleChange(index)}
              key={index}
            />
          );
        })}
        </tbody>
        {(allowAdd) &&
          <tfoot>
            <tr>
              <td colSpan="5">
                <button type="button"
                  className="parkchirp--button-as-link"
                  onClick={this.onAddVehicleClick}>
                  Add Vehicle
                </button>
              </td>
            </tr>
          </tfoot>
        }
      </table>
    );
  }
}
export default ParkerVehicleTable;
